import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as ActionCreators from '../../redux/action';
import FaqResultsContentSC, {
  SearchWrapSC,
  FaqsResultsBodySC,
  FaqsHeadlineSC,
  EmptyResultsSC,
} from './faq-results-content.styled';
import FaqSearch from '../faq-search';
import { SmallText, BodyText } from '../typography';
import { withRouter } from 'react-router-dom';
import ResultItem from './result-item';
import { FormattedMessage } from 'react-intl';
import dlt from '../../utils/default-lang';
import Button from '../ui/button';

const _FaqResultsContent = ({ getSearchedFAQs, searchResults, match }) => {
  const uriSearchTerm = match.params.term;

  useEffect(() => {
    getSearchedFAQs(uriSearchTerm);
  }, [uriSearchTerm, getSearchedFAQs]);

  const onEmailClick = () => {
    window.location = 'mailto:support@wishmaker.io';
  };

  return (
    <FaqResultsContentSC>
      <SearchWrapSC>
        <FaqSearch />
      </SearchWrapSC>
      <FaqsResultsBodySC>
        <FaqsHeadlineSC>Results</FaqsHeadlineSC>
        <SmallText className="result-text">
          Showing <b>{searchResults.length}</b> results for <b>“{uriSearchTerm}”</b>
        </SmallText>
        {searchResults.length !== 0 ? (
          <>
            {searchResults.map((result) => {
              return <ResultItem key={result.id} question={result.question} faqId={result.id} />;
            })}{' '}
          </>
        ) : (
          <EmptyResultsSC>
            <span className="result-text">Not results</span>
            <span className="not-find-text">Can not find the answer to your question?</span>
            <div>
              <BodyText className="black-transparent">
                <FormattedMessage
                  id="global_contact_us"
                  defaultMessage={dlt['global_contact_us']}
                />
              </BodyText>
              <Button type="LINK" onClick={() => onEmailClick()}>
                support@wishmaker.io
              </Button>
            </div>
          </EmptyResultsSC>
        )}
      </FaqsResultsBodySC>
    </FaqResultsContentSC>
  );
};

const mapStateToProps = (state) => {
  return {
    searchResults: state.faq.searchResults,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getSearchedFAQs: ActionCreators.getSearchedFAQs,
    },
    dispatch
  );
};

const FaqResultsContent = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(_FaqResultsContent)
);

export default FaqResultsContent;
